import { plainToInstance } from 'class-transformer'
import { Guid } from 'guid-typescript'

import {
  BaseButton,
  ButtonTypes
} from '../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/types'
import BaseButtonBuilder, { BaseButtonViewData } from '../index'
import buttonView from './ShareButtonView.vue'
import setupView from './ShareSetupView.vue'

export default class ShareButtonBuilder extends BaseButtonBuilder {
  type = ButtonTypes.Share

  titleKey = ButtonTypes.Share

  buttonView = buttonView
  setupView = setupView

  icon = '📢'

  data = { text: '' }

  getData(button?: ShareButton): ShareButtonData {
    return new ShareButtonData(button ? button.text : this.$i18n.t('initial_text_message_editor_buttons').toString())
  }

  create(): ShareButton {
    return plainToInstance(ShareButton, {
      ...this.data,
      type: ButtonTypes.Share,
      guid: Guid.create().toString(),
    })
  }
}

export class ShareButtonData implements BaseButtonViewData {
  text: string

  constructor(text: string) {
    this.text = text
  }
}

export class ShareButton implements BaseButton {
  text!: string
  type!: ButtonTypes.Share
  guid!: string
}
